exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recycle-art .tip{line-height:.98666667rem;padding-left:.4rem;font-size:.34666667rem;color:#ababab}", ""]);

// exports
